export const InvalidData = ({ text }: { text: string }) => (
  <span className="text-danger-500 text-[13px] leading-[22px]">{text}</span>
);
